<template>
  <div class="student-notice-layout">
    <div v-html="content"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      content:
        '<article><h2>特别提示</h2><section>本须知关乎您（用户）的切身利益，在确认预订展示的产品前，请您仔细阅读。本须知及产品页面中的“产品简介”、”商家详情”，“退款说明”及其他提示、须知等提示性内容（以下简称“产品页面提示”）作为双方协议的补充内容。当您购买产品时，即表明您已经仔细阅读并接受本须知及产品页面提示的所有内容。 </section> </article> <article><h2>温馨提示</h2><ul><li>· 此产品核销前会有课程顾问和您取得联系，确认报 名的时间、地点和材料等情况，确认无误报名成功后进行核销；  </li>  <li>· 此产品为知识付费产品，产品一经核销后概不退换；  </li>  <li>· 报考学员在提交报名材料过程中如出现材料与事实不符，影响报名或拿证，责任由学员自行承担；  </li>  <li>· 报考学员如因个人原因中途退出的，视为放弃参加考试，责任由本人承担。  </li>  </ul>  </article>  <article>  <h2>退款规则</h2>  <section>请您购买时仔细阅读产品页面退款说明，如您下单后需退款 请按退款说明进行退款申请。一笔订单多单下单或多次服务不支持部分退款。  </section>  </article>  <article>  <h2>其他说明</h2>  <section>  <label>发票：</label>消费后可申请开取发票，发票金额为实际付款金额（不包含优惠等部分）第三方商家需要在消费时向第三方机 构索取发票。  </section>  </article>'
    }
  },
  created() {
    this.getCmsContent()
  },

  methods: {
    async getCmsContent() {
      try {
        this.$$loading(true)
        const res = await this.$$fetch(
          '//cms.cekid.com/publish/999/confirm-skill-notic.json'
        )
        const json = await res.json()
        this.$$loading(false)
        if (json.code == 0 && json.data && json.data.content) {
          this.content = json.data.content
        }
      } catch (e) {}
    }
  }
}
</script>

<style lang="scss">
@import '~@/assets/css/mixin';
.student-notice-layout {
  min-height: 100vh;
  color: #000000;
  padding: 0 rem(30px);
  padding-bottom: rem(36px);
  article {
    padding-top: rem(36px);
    font-size: rem(30px);
    line-height: rem(42px);
    h2 {
      font-size: rem(32px);
      font-weight: 600;
      padding-bottom: rem(20px);
    }
    label {
      font-weight: 600;
    }
  }
}
</style>
